import HeroCreativitySection from '../../components/HeroCreativitySection/HeroCreativitySection';
import StayAwhileSection from '../../components/StayAwhileSection/StayAwhileSection';
import IntroStudioSection from '../../components/IntroStudioSection/IntroStudioSection';
import HowCanIHelpSection from '../../components/HowCanIHelpSection/HowCanIHelpSection';
import ChatSection from '../../components/ChatSection/ChatSection';
import styles from './Home.module.css';

const Home = () => {
  return (
    <div className={styles.homeContainer}>
    <HeroCreativitySection />
    <StayAwhileSection />
    <IntroStudioSection />
    <HowCanIHelpSection />
    <ChatSection />
    </div>
  );
};

export default Home;